module.exports = __webpack_public_path__ + "img/arrow.38120820.svg";